import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_prov_special_health_and_safety_trainings_separate'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_prov_special_health_and_safety_trainings_separate',
  name: 'Does the facility provide special Health and Safety trainings (separate from normal adult training) to workers under the age of 18?',
  description:
    'The intent of this question is to understand if the facility (regardless of what the law states) administers special HS trainings for young workers. \r\r\n\r\r\n"Special HS trainings" refers to trainings given to young workers SEPARATE from normal adult trainings. It covers the idea that young workers, new to the workforce, receive specialized instruction on HS matters.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'cl-4--7',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 4560,
  sectionId: '2.2.1',
  impactArea: 'Child Labour',
  impactAreaId: 'CHILD_LABOR',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
